module.exports = __webpack_public_path__ + "img/LaPerlaRecortada.9e3e1fca.jpg";